export default __webpack_public_path__ + "static/media/Fiche Agreable.8ea8441f.pdf";